import state from './state.js'
import mutations from './mutations.js'
import actions from './actions.js'
import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex);
export default new Vuex.Store({ 
	state,
	mutations,
	actions
})


// WEBPACK FOOTER //
// ./src/vuex/vuex.js